<template>
  <v-dialog v-model="dOpenAdminAlmacenes" persistent width="800px">
    <!--Cabecera-->
    <v-card>
      <v-card-title class="data-bgPrimaryColor white--text data-headerModal">
        <div>
          <v-flex xs12 pl-2>
            <span class="data-title">{{ $t('confAlmacenes') }}</span>
          </v-flex>
          <v-flex xs2 class="iconClose">
            <v-btn class="close" flat icon color="white" @click="$emit('close')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-3">
        <v-dialog v-if="true" v-model="dLoading" hide-overlay persistent width="300">
          <v-card class="datModalTitleContainer" dark>
            <v-card-text>
              {{ $t('cargandoContenido') }}
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-flex>
          <v-layout row wrap>
            <v-flex text-xs-center class="mb-3">
              <!-- ALMACENES -->
              <v-data-table style="background-color: red;" :key="dAlmTablaKey" item-key="almacen" :loading="dLoading"
                single-expand :no-results-text="this.$t('noResultados')" :no-data-text="this.$t('noResultados')"
                :rows-per-page-text="$t('numCertifPagina')" v-bind:pagination.sync="dPaginationAlm"
                :total-items="dTotalItemsAlm" class="tablePedidos" :rows-per-page-items="dRowsPerPageItemsAlm"
                :items="dDatosTablaAlm" :headers="dHeadersTableAlm">
                <template slot="headers" slot-scope="props">
                  <tr class="lightPrimaryColorBackground">
                    <th class="text-xs-center" v-for="header in props.headers" :key="header.key" :id="header.value"
                      :class="['column sortable', dPaginationAlm.descending ? 'desc' : 'asc', header.value === dPaginationAlm.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']">
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="text-xs-center ellipsis" @click="fGetUbicaciones(props)">
                      <v-icon class="cursorPointer" :class="props.expanded ? 'iconRotate' : ''">
                        arrow_downward
                      </v-icon>
                    </td>
                    <td class="text-xs-left ellipsis">
                      <span>{{ props.item.almacen }} - {{ props.item.nombre }}</span>
                    </td>
                    <td class="text-xs-center ellipsis d-flex align-center justify-center">
                      <v-checkbox @change="modificarCheckAlm('ALM', props.item)" v-model="props.item.marcado"
                        hide-details solo-invert></v-checkbox>
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <!-- UBICACIONES -->
                  <v-data-table :headers="dHeadersTableUbi" :items="dDatosTablaUbi" :loading="dLoading"
                    :pagination.sync="dPaginationUbi" :total-items="dTotalItemsUbi"
                    :rows-per-page-items="dRowsPerPageItemsUbi" class="subtitle-2" dense>
                    <template slot="headers" slot-scope="props">
                      <tr class="lighterPrimaryColorBackground">
                        <th class="text-xs-center" v-for="header in props.headers" :key="header.key" :id="header.value"
                          :class="['column sortable', dPaginationUbi.descending ? 'desc' : 'asc', header.value === dPaginationUbi.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']">
                          {{ header.text }}

                        </th>
                      </tr>
                    </template>
                    <template slot="items" slot-scope="{ item }">
                      <tr>
                        <td class="text-xs-left ellipsis">
                          <span>{{ item.ubicacion }} </span>
                        </td>
                        <td class="text-xs-left ellipsis">
                          <span>{{ item.nombre }}</span>
                        </td>
                        <td class="text-xs-center ellipsis d-flex align-center justify-center">
                          <v-checkbox @change="modificarCheckAlm('UBI', item)" v-model="item.marcado" hide-details
                            solo-invert></v-checkbox>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-flex xs12 text-xs-right>
          <v-btn class=" datPrimaryBtn" flat @click="fActualizaAdmAlmUbi()">{{ $t('aceptar') }}</v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SrvGeneral from '@/services/srv-general'
export default {
  props: {
    dOpenAdminAlmacenes: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  data() {
    return {
      dAlmTablaKey: 0,
      dHeight: 'calc(100vh - 300px)',
      dLoading: false,
      dSeleccionAlmacenes: {
        almacenes: [],
        ubicaciones: []
      },
      dHeadersTableAlm: [],
      dDatosTablaAlm: [],
      dPaginationAlm: { 'sortBy': 'centro', 'descending': false, 'rowsPerPage': 10, 'page': 1 },
      dTotalItemsAlm: 0,
      dRowsPerPageItemsAlm: [5, 10, 25],
      dFirstSortTableAlm: 0,

      dHeadersTableUbi: [],
      dDatosTablaUbi: [],
      dPaginationUbi: { 'sortBy': 'ubicacion', 'descending': false, 'rowsPerPage': 5, 'page': 1 },
      dTotalItemsUbi: 0,
      dRowsPerPageItemsUbi: [5, 10, 25],
      currentAlm: '',
      dAlmacenesMarcados: [],
      eventoMostrar: 'evento-mostrarAvisos'
    }
  },
  created() {
    this.fGetDataAlmacenes();
  },
  methods: {
    fGetDataAlmacenes() {
      this.fIniciarVariables();
      this.fGetAlmacenesMarcados().then(response => {
        this.dAlmacenesMarcados = [];
        if (!response.errorMsg) {
          this.dAlmacenesMarcados = response.result;
        }
      });
    },
    fIniciarVariables() {
      this.dHeadersTableAlm = [
        { key: 'arrow', text: '', align: 'left', value: 'arrow', sortable: false },
        { key: 'almacen', text: this.$t('almacen'), align: 'left', value: 'almacen', sortable: false },
        { key: 'check', text: '', align: 'left', value: 'check', sortable: false },
      ]
      this.dHeadersTableUbi = [
        { key: 'ubicacion', text: this.$t('ubicacion'), align: 'left', value: 'ubicacion', sortable: false },
        { key: 'descripcion', text: this.$t('descripcion'), align: 'left', value: 'descripcion', sortable: false },
        { key: 'check', text: '', align: 'left', value: 'check', sortable: false },
      ]
      this.dSeleccionAlmacenes = {
        almacenes: [],
        ubicaciones: []
      };
      this.dDatosTablaAlm = [];
      this.dTotalItemsAlm = 0;
      this.dFirstSortTableAlm = 0;
      this.dDatosTablaUbi = [];
      this.dTotalItemsUbi = 0;
      this.dFirstSortTableUbi = 0;
      this.currentAlm = '';
      this.dAlmacenesMarcados = [];
    },
    fRespuestaCorrecta(response) {
      let finalValue = false;
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        finalValue = true
      }
      return finalValue
    },
    fGetAlmacenesMarcados() {
      this.dLoading = true;
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion,
        empresa: this.$store.getters.getAutenticacion.empresa,
        offset: this.dPaginationAlm.rowsPerPage * (this.dPaginationAlm.page - 1) + 1,
        numRows: this.dPaginationAlm.rowsPerPage,
        orderBy: this.dPaginationAlm.sortBy,
        order: this.dPaginationAlm.descending ? 'DESC' : 'ASC'
      };
      return SrvGeneral.administracionAlmUbi(payload)
        .then(response => {
          const datos = response.data.dataRes;
          this.dLoading = false;
          if (!this.fRespuestaCorrecta(response)) {
            return response.data;
          }
          return datos;
        });
    },
    fGetAlmacenes() {
      this.dDatosTablaAlm = [];
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion,
        empresa: this.$store.getters.getAutenticacion.empresa,
        offset: this.dPaginationAlm.rowsPerPage * (this.dPaginationAlm.page - 1) + 1,
        numRows: this.dPaginationAlm.rowsPerPage,
        orderBy: this.dPaginationAlm.sortBy,
        order: this.dPaginationAlm.descending ? 'DESC' : 'ASC'
      }
      try {
        // Lista de valores de almacenes
        SrvGeneral.lovAlm(payload).then((response) => {
          if (!this.fRespuestaCorrecta(response)) {
            throw new Error(response.data.errorMsg.message);
          }
          const datos = response.data.dataRes;
          // 
          if (Array.isArray(datos)) {
            datos.forEach(item => {
              const marcado = this.dAlmacenesMarcados.some(itemM => itemM.almacen === item.almacen);
              this.dDatosTablaAlm.push({
                "centro": item.centro,
                "almacen": item.almacen,
                "nombre": item.nombre,
                "marcado": marcado
              });
            });
          }
          this.dTotalItemsAlm = response.data.numReg
          this.dLoading = false
        });
      } catch (error) {
        this.dLoading = false
        this.$bus.$emit(this.eventoMostrar, `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
      }
    },
    fGetUbicaciones(props) {
      // Reiniciamos variables de paginación
      props.expanded = !props.expanded;
      // 
      if (!props.expanded) {
        this.currentAlm = null;
        this.dTotalItemsUbi = 0;
        this.dDatosTablaUbi = [];
        return;
      }
      this.currentAlm = props;
      this.dPaginationUbi.page = 1;
      // 
      this.fCargaUbi();
    },
    fCargaUbi() {
      this.dFirstSortTableUbi = 0;
      this.dLoading = true;
      if (!this.currentAlm) {
        return;
      }

      this.dDatosTablaUbi = [];
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion,
        empresa: this.$store.getters.getAutenticacion.empresa,
        offset: this.dPaginationUbi.rowsPerPage * (this.dPaginationUbi.page - 1) + 1,
        almacen: this.currentAlm.item.almacen,
        numRows: this.dPaginationUbi.rowsPerPage,
        orderBy: this.dPaginationUbi.sortBy,
        order: this.dPaginationUbi.descending ? 'DESC' : 'ASC'
      }
      try {
        // Lista de valores de ubicaciones
        SrvGeneral.lovUbi(payload).then((response) => {
          if (!this.fRespuestaCorrecta(response)) {
            this.dLoading = false
            this.$bus.$emit(this.eventoMostrar, response.data.errorMsg.message || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
            return
          }
          const datos = response.data.dataRes;
          // 
          if (Array.isArray(datos)) {
            datos.forEach(item => {
              const almacenActual = this.dAlmacenesMarcados.find(itemM => itemM.almacen === this.currentAlm.item.almacen);
              let marcado = false;
              if (almacenActual) {
                marcado = almacenActual.ubicaciones.some(itemU => itemU.ubicacion === item.ubicacion);
              }
              const ubiSeleccinada = this.dSeleccionAlmacenes.ubicaciones.find(itemU => itemU.ubicacion === item.ubicacion);
              if (ubiSeleccinada) {
                marcado = ubiSeleccinada.marcado === 'S' ? true : false;
              }
              // 
              this.dDatosTablaUbi.push({
                "centro": item.centro,
                "almacen": item.almacen,
                "ubicacion": item.ubicacion,
                "nombre": item.nombreUbicacion,
                "marcado": marcado
              });
            });
          }
          this.dTotalItemsUbi = response.data.numReg
          this.dLoading = false
        });
      } catch (error) {
        this.$bus.$emit(this.eventoMostrar, `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
      }
    },
    fActualizaAdmAlmUbi() {
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion,
        empresa: this.$store.getters.getAutenticacion.empresa,
        gestionAlmUbi: this.dSeleccionAlmacenes
      }
      try {
        // Actualiza los almacenes y ubicaciones
        SrvGeneral.actualizaAlmUbi(payload).then((response) => {
          if (!this.fRespuestaCorrecta(response)) {
            this.dLoading = false
            this.$bus.$emit(this.eventoMostrar, `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
            return
          }
          this.$bus.$emit(this.eventoMostrar, this.$t('actCorrectamente'))
        });
      } catch (error) {
        this.$bus.$emit(this.eventoMostrar, `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
      }
    },
    marcarCheckAlm(props) {
      // Buscamos el array
      const indAlm = this.dSeleccionAlmacenes.almacenes.findIndex(a => a.almacen === props.almacen);
      if (indAlm !== -1) {
        // Si existe, actualiza el valor de "marcado"
        this.dSeleccionAlmacenes.almacenes[indAlm].marcado = props.marcado ? 'S' : 'N';
      } else {
        // Si no existe lo agregamos
        this.dSeleccionAlmacenes.almacenes.push({
          almacen: props.almacen,
          centro: props.centro,
          marcado: props.marcado ? 'S' : 'N'
        });
      }
    },
    modificarCheckAlm(tipoReg, props) {
      if (tipoReg === 'ALM') {
        this.marcarCheckAlm(props);
      } else if (tipoReg === 'UBI') {
        const indUbi = this.dSeleccionAlmacenes.ubicaciones.findIndex(
          u => u.almacen === props.almacen && u.ubicacion === props.ubicacion
        );
        if (indUbi !== -1) {
          this.dSeleccionAlmacenes.ubicaciones[indUbi].marcado = props.marcado ? 'S' : 'N';
        } else {
          this.dSeleccionAlmacenes.ubicaciones.push({
            almacen: props.almacen,
            centro: props.centro,
            ubicacion: props.ubicacion,
            marcado: props.marcado ? 'S' : 'N'
          });
        }
        if (props.marcado) {
          this.marcarCheckAlm(props);
          const indAlm = this.dDatosTablaAlm.findIndex(a => a.almacen === props.almacen);
          this.dDatosTablaAlm[indAlm].marcado = 'S';
        }
      }
    }
  }, watch: {
    dPaginationAlm: {
      handler(newPage, oldPage) {
        if (this.dFirstSortTableAlm > 0) {
          this.fGetAlmacenes()
        }
        this.dFirstSortTableAlm++
      },
      deep: true
    },
    dPaginationUbi: {
      handler(newPage, oldPage) {
        if (!this.currentAlm) {
          return;
        }
        if (this.dFirstSortTableUbi > 0) {
          this.fCargaUbi();
        }
        this.dFirstSortTableUbi++;
      }
    },
    dOpenAdminAlmacenes: {
      handler(newPage, oldPage) {
        if (this.dOpenAdminAlmacenes) {
          this.dAlmTablaKey++; //Fuerza que se reinicie los expanded al acceder.
          this.fGetDataAlmacenes();
        }
      },
      deep: true
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Administracion/ShpAdministracionAlmacenes.vue